import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSquareBehindSquare1"><Path fillRule="evenodd" clipRule="evenodd" d="M2 2H16V8H22V22H8V16H2V2ZM14 8H8V14H4V4H14V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareBehindSquare1;
